import { useAuth } from "@/contexts/AuthContext";

const VAULT_COLORS = {
  TAX_CUSTODY:             { bg: "#065F46", fill: "#10B981", lid: "#059669" },
  SUPPLIER_OBLIGATION:     { bg: "#78350F", fill: "#F59E0B", lid: "#D97706" },
  CUSTOMER_TRUST:          { bg: "#1E3A5F", fill: "#3B82F6", lid: "#2563EB" },
  INVENTORY_CUSTODY:       { bg: "#3B1F6E", fill: "#8B5CF6", lid: "#7C3AED" },
  OPERATING_CUSTODY:       { bg: "#1E2A5E", fill: "#1E40AF", lid: "#1D4ED8" },
  FREE_EQUITY:             { bg: "#4A3700", fill: "#FFD700", lid: "#EAB308" },
  // Expansion 4
  CREDIT_FACILITY_CUSTODY: { bg: "#5B0F2A", fill: "#EC4899", lid: "#DB2777" }, // pink/magenta — borrowed liquidity
  LOAN_OBLIGATION:         { bg: "#5B1A0A", fill: "#EF4444", lid: "#DC2626" }, // red — debt
  RESERVE_CAPITAL:         { bg: "#0F3D3D", fill: "#14B8A6", lid: "#0D9488" }, // teal — protected
  STRATEGIC_CAPITAL:       { bg: "#3F2E0A", fill: "#FB923C", lid: "#F97316" }, // orange — growth
};

export default function VaultCylinder({ vault, formatMoney, onClick }) {
  const { i18n } = useAuth();
  const colors = VAULT_COLORS[vault.vault_type] || VAULT_COLORS.FREE_EQUITY;
  const label = i18n(`vault.${vault.vault_type}`);
  const maxBalance = 150000;
  const fillPct = Math.min(95, Math.max(10, (vault.balance / maxBalance) * 100));

  return (
    <button
      onClick={() => onClick?.(vault)}
      className="vault-cylinder flex flex-col items-center cursor-pointer focus:outline-none group"
      data-testid={`vault-cylinder-${vault.vault_type.toLowerCase().replace(/_/g, '-')}`}
      aria-label={`${label}: ${formatMoney(vault.balance)}`}
    >
      <div className="vault-lid shadow-lg" style={{ background: `radial-gradient(ellipse at 40% 40%, ${colors.fill}88, ${colors.lid})` }} />
      <div className="vault-body border-x border-b rounded-b-lg" style={{ background: `linear-gradient(180deg, ${colors.bg} 0%, #0F172A 100%)`, borderColor: `${colors.fill}30`, height: '90px' }}>
        <div className="vault-fill rounded-b-lg" style={{ background: `linear-gradient(180deg, ${colors.fill}60, ${colors.fill}20)`, height: `${fillPct}%` }} />
      </div>
      <div className="vault-base shadow-md" style={{ background: `radial-gradient(ellipse at 50% 60%, ${colors.bg}, #0F172A)` }} />
      <span className="mt-2 text-[11px] text-slate-400 font-manrope text-center leading-tight group-hover:text-slate-200 transition-colors">
        {label}
      </span>
      <span className="text-sm font-mono font-semibold text-slate-100 tabular mt-0.5" style={{ color: colors.fill }}>
        {formatMoney(vault.balance)}
      </span>
    </button>
  );
}
